module.exports = __webpack_public_path__ + "assets/img/returnBtn-4d8bc144.png";